export default {
  home: '/',
  login: '/login',

  version: '/version',
  cookiebotPreview: '/cookiebot-preview',
  notFound: '/not-found',

  selectAccount: '/select-account',
  accountError: '/account-error',
  accountBackground: '/account-background',
  documents: '/documents',
  paymentHistory: '/payment-history',
  accountSettings: '/account-settings',
  
  paymentPlan: '/payment-plan',
  legacyPaymentPartial: '/payment-plan/partial',
  legacyPaymentPlanCreate: '/payment-plan/create',
  paymentPlanSetup: '/payment-plan/setup',
  paymentPlanError: '/payment-plan/error',
  shortLinkError: '/short-link/error',
  paymentConfirm: '/payment-confirm',
  paymentSuccess: '/payment-success',
    
  shortLink: '/:ref/:shortUrlPath',
  
  settlementOfferLandingPage: '/special-offer/user/:referenceNumber',
  paymentPlanOfferLandingPage: '/payment-plan/user/:referenceNumber',
  specialOfferError: '/special-offer/error',

  frictionlessLandingPage: '/pay-now/user/:referenceNumber',

  disclosures: '/disclosures',
  uniqueDisclosures: '/disclosures/:referenceNumber',
  homeDisclosures: '/home-disclosures',
};
